interface NumberCardProps {
  number: string;
  title: string;
  text: string;
}

export const NumberCard = ({ number, title, text }: NumberCardProps) => {
  return (
    <div className="bg-white border border-white shadow-lg rounded-lg flex justify-between p-8 mb-6 last:mb-0">
      <div className="self-center mr-8">
        <h1 className="text-orange-500 font-bold text-5xl">{number}</h1>
      </div>
      <div>
        <h3 className="text-lg font-semibold">{title}</h3>
        <p className="text-[#49505A]">{text}</p>
      </div>
    </div>
  );
};
